module.exports = __webpack_public_path__ + "media/images/smart_phone/item/rate_3_5-c14be2fb1a98d57f61f5a1b038ff9d3d.png";